export enum IMAGE_SIZES {
  MAX_IMG_WIDTH_THUMBNAIL = 450,
  MAX_IMG_WIDTH = 1800,
}
